export default "__VITE_PUBLIC_ASSET__f43b556f__"